<template>
  <div :class="{ 'container my-4': !isMobile }" v-if="orderDetails">
    <div class="order-details p-4">
      <div v-for="(order, index) in orderDetails.orders" :key="'order' + index">
        <div v-if="order.uuid">
          <div class="header">
            <div class="py-3">
              <b-row v-if="order.uuid">
                <b-col class="px-0">
                  <h3 class="mb-4">
                    {{ order.brand_name }} ({{ order.branch }})
                  </h3>
                  <b-row>
                    <b-col cols="6" lg="2"><h3>Order ID</h3></b-col>
                    <b-col
                      ><p>{{ order.order_no }}</p></b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col cols="7" lg="2"><h3>Delivery Type</h3></b-col>
                    <b-col>
                      <p>
                        <template
                          v-if="
                            ['pickup', 'pick up'].includes(
                              order.delivery_type.toLowerCase()
                            )
                          "
                        >
                          Pickup Now
                        </template>
                        <template
                          v-else-if="
                            order.delivery_type.toLowerCase() === 'delivery'
                          "
                        >
                          Deliver Now
                        </template>
                        <template v-else>
                          {{ order.delivery_type }}
                        </template>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="header">
            <b-row>
              <b-col>
                <h2>{{ order.delivery_type }} Address</h2>
                <div class="delivery-address">
                  <b-row>
                    <b-col lg="3">
                      <div class="rounded overflow-hidden">
                        <GmapMap
                          :center="{
                            lat: orderDetails.lat,
                            lng: orderDetails.lng
                          }"
                          :zoom="7"
                          style="width: 100%; height: 100px"
                          ref="deliveryAddressMap"
                          :options="{
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: false,
                            disableDefaultUI: false
                          }"
                        >
                        </GmapMap>
                      </div>
                    </b-col>
                    <b-col
                      v-if="
                        order.delivery_type == 'Deliver Later' ||
                          order.delivery_type == 'Delivery'
                      "
                    >
                      <h3 class="mb-4">{{ order.delivery_address }}</h3>
                      <p class="lead text-capitalize ml-3">
                        {{ order.delivery_address_details }}
                      </p>
                      <div
                        v-if="
                          order.delivery_type == 'Deliver Later' ||
                            order.delivery_type == 'Pick Up Later'
                        "
                      >
                        <p class="text-capitalize font-weight-bold ml-3">
                          Deliver later date and time
                        </p>
                      </div>
                      <p
                        class="text-capitalize ml-3"
                        v-if="order.pickup_datetime"
                      >
                        {{ getMoment(order.pickup_datetime) }}
                      </p>
                    </b-col>
                    <b-col v-else>
                      <h3 class="mb-4">{{ order.brand_name }}</h3>
                      <p class="lead text-capitalize ml-3">
                        {{ order.delivery_address }},
                        {{ order.branch_address.city }},
                        {{ order.branch_address.province }}
                        {{ order.branch_address.zip }}
                      </p>
                      <div
                        v-if="
                          order.delivery_type == 'Deliver Later' ||
                            order.delivery_type == 'Pick Up Later'
                        "
                      >
                        <p
                          class="text-capitalize font-weight-bold ml-3"
                          v-if="order.delivery_type == 'Deliver Later'"
                        >
                          Deliver later date and time
                        </p>
                        <p class="text-capitalize font-weight-bold ml-3" v-else>
                          Pick up date and time
                        </p>
                      </div>
                      <p
                        class="text-capitalize ml-3"
                        v-if="order.pickup_datetime"
                      >
                        {{ getMoment(order.pickup_datetime) }}
                      </p>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-overlay :show="isOrderStatusDesignLoading" class="header">
            <template v-if="!isOrderStatusDesignLoading">
              <b-row v-if="order.status !== 'cancelled'">
                <b-col>
                  <OrderStatusGif :status="order.status" />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <h2>Order Status</h2>
                  <b-container
                    v-if="order.status !== 'cancelled'"
                    class="order-progress-container"
                  >
                    <b-row>
                      <b-col>
                        <OrderStatusProgress
                          :orderType="order.delivery_type"
                          :status="order.status"
                        />
                      </b-col>
                    </b-row>
                    <!-- Start Follow Up and Cancel Order: for Cart Linking Drop 2 <b-row class="mt-4">
                      <b-col lg="6" class="mx-auto">
                        <b-row>
                          <b-col
                            lg="6"
                            :class="[
                              'text-center',
                              { 'mx-auto': !order.cancel_available }
                            ]"
                          >
                            <b-button
                              variant="primary"
                              pill
                              block
                              class="order-action-buttons border-0"
                              :style="{
                                backgroundColor:
                                  webDesign && webDesign.design
                                    ? `${webDesign.design.main_color}`
                                    : null,
                                color:
                                  webDesign && webDesign.design
                                    ? `${webDesign.design.button_text_color} !important`
                                    : null
                              }"
                              @click="followUpOrder"
                              :disabled="
                                (order.status !== 'pending' &&
                                  order.status !== 'processing') ||
                                  !order.follow_up_available
                              "
                            >
                              FOLLOW UP ORDER
                            </b-button>
                            <small
                              v-if="
                                (order.status !== 'pending' &&
                                  order.status !== 'processing') ||
                                  !order.follow_up_available
                              "
                              class="text-primary font-weight-bold"
                            >
                              Sent follow up to the store
                            </small>
                          </b-col>
                          <b-col
                            lg="6"
                            class="text-center mt-3 mt-lg-0"
                            v-if="order.cancel_available"
                          >
                            <b-button
                              block
                              class="
                                order-action-buttons
                                text-uppercase
                                bg-transparent
                                shadow-none
                                text-danger
                                border-0
                              "
                              @click="
                                $root.$emit(
                                  'bv::show::modal',
                                  'confirm-cancel-order'
                                )
                              "
                              pill
                            >
                              Cancel Order
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    End Follow Up and Cancel Order: for Cart Linking Drop 2 -->
                  </b-container>
                  <span v-else class="status text-capitalize cancelled">
                    Cancelled
                  </span>
                </b-col>
              </b-row>
            </template>
          </b-overlay>
          <div class="header">
            <h2>My Order</h2>
            <b-row
              no-gutters
              v-for="(item, index) in order.order_items"
              :key="index"
              class="mb-3"
            >
              <b-col cols="1">
                <template v-if="item.images.length > 0">
                  <img
                    :src="item.images[0].image_name"
                    alt
                    class="d-inline-block mr-3 img-thumbnail product-image"
                  />
                </template>
              </b-col>
              <b-col cols="2">
                <p class="text-center">{{ parseInt(item.quantity) }}x</p>
              </b-col>
              <b-col cols="6" md="7">
                <div class="d-inline-block">
                  <p class="font-weight-bold word-break-all">
                    {{ item.product_name }}
                  </p>
                  <template
                    v-if="parseVariationDesc(item.variation_desc).length > 0"
                  >
                    <span
                      class="d-block mb-1 variation-desc"
                      v-for="(variationDesc, index) in parseVariationDesc(
                        item.variation_desc
                      )"
                      :key="`variationDescription${index}`"
                    >
                      <span class="font-weight-bold"
                        >{{ variationDesc.attribute }}:
                      </span>
                      <span>{{ variationDesc.value }}</span>
                    </span>
                  </template>
                  <!-- Start: Add-Ons -->
                  <template v-if="item.add_ons.length > 0">
                    <span class="font-weight-bold d-block">Add Ons:</span>
                    <div v-for="(addon, index) in item.add_ons" :key="index">
                      <span class="variation-desc d-block">
                        {{ addon.name }} -
                        {{ addon.is_free ? "Free" : "+&#8369;" + addon.price }}
                      </span>
                    </div>
                  </template>
                  <!-- End: Add-Ons -->
                  <!-- Start: Add-Ons -->
                  <template v-if="item.instructions !== ''">
                    <span class="font-weight-bold d-block"
                      >Special Instructions:</span
                    >
                    <span class="variation-desc d-block">{{
                      item.instructions
                    }}</span>
                  </template>
                  <!-- End: Add-Ons -->
                </div>
              </b-col>
              <b-col class="text-right">
                <span class="item-amount font-weight-bold">
                  &#8369;
                  {{ putComma(Number(item.total_amount).toFixed(2)) }}
                </span>
              </b-col>
            </b-row>
            <hr />
          </div>
          <div class="header individual-order p-3">
            <b-row class="mb-2">
              <b-col
                class="font-weight-normal d-flex justify-content-end"
                cols="6"
                lg="10"
                ><div :class="[isMobile ? 'w-90' : 'w-15']">
                  Sub Total
                </div></b-col
              >
              <b-col class="font-weight-normal text-right">
                &#8369; {{ putComma(orderDetails.total) }}
              </b-col>
            </b-row>
            <b-row
              v-for="(fee, index) in order.fees"
              :key="`per_branch_fee_${index}`"
              class="mb-2"
            >
              <b-col
                cols="6"
                lg="10"
                class="font-weight-normal d-flex justify-content-end"
              >
                <div :class="[isMobile ? 'w-90' : 'w-15']">{{ fee.name }}</div>
              </b-col>
              <b-col class="font-weight-normal text-right">
                &#8369; {{ fee.calculated_amount | price }}
              </b-col>
            </b-row>
            <!-- <template v-if="orderDetails.voucher_amount != null"> -->
            <!-- Start: MEDPadala Credits -->
            <template v-if="hasMEDPadalaCustomization">
              <b-row class="mb-2" v-if="medPadalaCustomization">
                <b-col cols="6" lg="10" class="d-flex justify-content-end">
                  <div :class="[isMobile ? 'w-90' : 'w-15']">
                    <img
                      :src="medPadalaCustomization.logo"
                      alt="MEDPadala Credits"
                      class="medpadala-logo"
                    />
                  </div>
                </b-col>
                <b-col
                  class="text-right"
                  :style="{
                    color:
                      webDesign && webDesign.design
                        ? `${webDesign.design.main_color} !important`
                        : null
                  }"
                >
                  <b
                    >- &#8369;
                    {{ medPadalaCustomizations.values.amount | price }}</b
                  >
                </b-col>
              </b-row>
            </template>
            <!-- End: MEDPadala Credits -->
            <template v-if="orderDetails.voucher_amount > 1">
              <b-row class="mb-2">
                <b-col
                  cols="6"
                  lg="10"
                  class="font-weight-normal d-flex justify-content-end"
                >
                  <div :class="[isMobile ? 'w-90' : 'w-15']">
                    Promo ({{ orderDetails.voucher_code }})
                  </div>
                </b-col>
                <b-col class="text-right font-weight-bold text-primary">
                  - &#8369;
                  {{
                    calculateVoucherAmount(
                      orderDetails.orders,
                      orderDetails.voucher_amount
                    ) | price
                  }}
                </b-col>
              </b-row>
            </template>
          </div>
          <b-row>
            <b-col cols="6" lg="10">
              <div
                class="
                  font-weight-bold
                  total
                  text-primary
                  px-2
                  d-flex
                  justify-content-end
                "
              >
                <div :class="[isMobile ? 'w-90' : 'w-15']">Total</div>
              </div>
            </b-col>
            <b-col>
              <p
                class="font-weight-bold text-right total pr-3"
                style="color: #ff8a00">
                &#8369;
                {{ putComma(orderDetails.computed_total) }}
              </p>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <ConfirmCancelOrderModal :orderId="$route.params.checkout_uuid" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import { Decimal } from "decimal.js";
import moment from "moment";
import ConfirmCancelOrderModal from "./ConfirmCancelOrder";
import OrderStatusGif from "./OrderStatusGif";
import OrderStatusProgress from "./OrderStatusProgress";

export default {
  components: {
    ConfirmCancelOrderModal,
    OrderStatusProgress,
    OrderStatusGif
  },
  data() {
    return {
      form: {
        depositSlip: null,
        reference_number: "",
        selectedBank: null
      },
      bankOptions: [],
      prevRoute: null,
      specificBank: null,
      // Google Map Options
      apiKey: "AIzaSyBZv6XyeHm4hdS2GyBTRwLZMgUAXv8k-JE",
      zoom: 8,
      isMobile: false,
      followUpOrderSleepInMinutes: 30,
      isOrderStatusDesignLoading: true
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  computed: {
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    ...mapState("estore", {
      estoreIsLoadingOverlay: state => state.loadingOverlay,
      estoreIsLoading: state => state.loading,
      estoreErrors: state => state.errors,
      webDesign: state => state.webDesign,
      isFollowUpOrderSent: state => state.isFollowUpOrderSent
    }),
    ...mapState("design", ["orderStatusDesign"]),
    ...mapGetters({
      medPadalaCustomization: "medpadala/medPadalaCustomization",
      orderDetails: "estore/orderDetails",
      storeDetails: "estore/storeDetails",
      customerToken: "customer/customerToken"
    }),
    hasMEDPadalaCustomization() {
      return this.orderDetails.customizations
        .map(customization => customization.type)
        .includes("med-padala");
    },
    medPadalaCustomizations() {
      return this.orderDetails.customizations.find(
        customization => customization.type === "med-padala"
      );
    }
  },
  methods: {
    getMoment(data) {
      return moment(data).isValid()
        ? moment(data).format("MMMM DD, YYYY (h:mm A)")
        : null;
    },
    formatDateTime(value, type) {
      if (value != null) {
        let data = value.split(" ");
        let retData;
        type == "date" ? (retData = data[0]) : (retData = data[1]);
        return retData;
      }
    },
    showBankModal(uuid) {
      if (this.storeDetails.bank_accounts.length > 0) {
        this.specificBank = this.storeDetails.bank_accounts.filter(
          bank => {
            if (bank.uuid == uuid) {
              return bank;
            }
          }
        );
      }
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    async getOrderDetails() {
      if (this.customerPortalToken != null) {
        let request = {
          header: {
            "X-Merchant-Token": this.customerPortalToken
          },
          tracking_uuid : this.$route.params.order_id
        };
        await this.$store.dispatch("estore/getOrderDetails", request);
      }
    },
    async uploadCustomerDepositSlip(evt) {
      evt.preventDefault();
      this.$store.dispatch("customer/resetErrors");
      this.$store.dispatch("estore/resetErrors");
      let depositSlip = this.form.depositSlip
        ? await this.getBase64(this.form.depositSlip)
        : null;
      depositSlip = depositSlip.replace(/data:image\/png;base64,/gi, "");
      depositSlip = depositSlip.replace(/data:image\/jpg;base64,/gi, "");
      depositSlip = depositSlip.replace(/data:image\/jpeg;base64,/gi, "");
      depositSlip = depositSlip.replace(/data:image\/gif;base64,/gi, "");

      let payload = {
        transaction_no: this.orderDetails.transaction_no,
        bank_uuid: this.form.selectedBank,
        deposit_slip: depositSlip,
        reference_no: this.form.reference_number
      };

      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: payload
      };
      let _this = this;
      await this.$store
        .dispatch("estore/uploadCustomerDepositSlip", request)
        .then(() => {
          if (_this.estoreErrors == null) {
            _this.getOrderDetails();
            _this.$refs["file-input"].reset();
            _this.depositSlip = null;
            _this.reference_number = "";
            _this.selectedBank = null;
            _this.$bvToast.toast("Successfully uploaded deposit slip.", {
              title: "Notification",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: true
            });
          }
        });
    },
    async getBase64(file) {
      return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    previousRoute(status) {
      let previousRoute = "/" + this.subdomain + "/orders/";
      if (status == "pending") {
        return previousRoute + "upcoming";
      }
      return previousRoute;
    },
    parseVariationDesc(variationDesc) {
      let parsedVariationDesc = JSON.parse(variationDesc);
      if (parsedVariationDesc.length > 0) {
        return parsedVariationDesc;
      }
      return [];
    },
    calculateTotal(transactionOrders = null, promo = null, fees = 0) {
      if (transactionOrders != null && fees != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let totalTransactionOrders = 0;
        let formattedPromo = 0;
        if (promo != null) {
          formattedPromo = Number(promo.toString().match(re)[0]);
        }

        for (let index = 0; index < transactionOrders.length; index++) {
          totalTransactionOrders += parseFloat(
            transactionOrders[index].order_item_total_amount
          );
        }

        totalTransactionOrders = new Decimal(
          Number(totalTransactionOrders.toString().match(re)[0])
        );

        formattedPromo = Number(formattedPromo.toString().match(re)[0]);
        let total = totalTransactionOrders.minus(formattedPromo);
        total = total < 0 ? 0 : total;
        let feesTotal = 0;

        for (let index = 0; index < fees.length; index++) {
          // if (fees[index].value_type == "%") {
          //   feesTotal += (totalTransactionOrders / 100) * fees[index].value;
          // } else {
          feesTotal += parseFloat(fees[index].calculated_amount);
          // }
        }

        feesTotal = Number(feesTotal.toString().match(re)[0]);
        return total.plus(feesTotal);
      }
    },
    calculateVoucherAmount(orders = null, promo = null) {
      if (orders != null && promo != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let formattedPromo = Number(promo.toString().match(re)[0]);
        return formattedPromo;
      }
    },
    calculateFee(orders = null, fee = null) {
      if (orders != null && fee != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let totalOrders = 0;
        for (let index = 0; index < orders.length; index++) {
          totalOrders += parseFloat(orders[index].order_item_total_amount);
        }
        totalOrders = new Decimal(Number(totalOrders.toString().match(re)[0]));
        if (fee.value_type == "%") {
          return totalOrders.dividedBy(100).times(fee.value);
        } else {
          return fee.value;
        }
      }
    },
    invalidFeedback(field) {
      if (this.estoreErrors == null) {
        return "";
      }
      return this.estoreErrors.errors[field];
    },
    state(field) {
      if (this.estoreErrors == null) {
        return false;
      }
      return this.estoreErrors.errors[field] ? false : true;
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    computeTotal(subtotal, promo) {
      if (promo == null) promo = 0;

      let re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");

      let subT = new Decimal(Number(subtotal.toString().match(re)[0]));

      let prom = new Decimal(Number(promo.toString().match(re)[0]));

      let total = subT.minus(prom);

      let formatTotal = this.putComma(total.toFixed(2));

      return formatTotal;
    },
    getDeliveryConfig(obj) {
      const branch = {};
      branch["brand"] = obj.brand_name;
      branch["brand_uuid"] = obj.brand_uuid;
      branch["branch"] = obj.branch;
      branch["branch_uuid"] = obj.branch_uuid;
      branch["deliveryType"] = obj.delivery_type;
      branch["pickup_datetime"] = obj.pickup_datetime;
      branch["fees"] = obj.fees;
      return branch;
    },
    async followUpOrder() {
      if (
        this.orderDetails &&
        this.orderDetails.orders &&
        this.orderDetails.orders.length
      ) {
        const request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken
          },
          uuid: this.uuid
        };

        await this.$store.dispatch("estore/followUpOrder", request).then(() => {
          if (this.isFollowUpOrderSent) this.getOrderDetails();
        });
      }
    },
    async getOrderStatusDesign() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      await this.$store.dispatch("design/getOrderStatusDesign", request);
    }
  },
  created: async function() {
    await this.getOrderDetails();
    // await this.getOrderStatusDesign(); OPEN API needed

    this.isOrderStatusDesignLoading = false;
    this.isMobile = window.innerWidth < 845;
  },
  filters: {
    truncate: function(text, length) {
      let imageFormat = text.substr(text.length - 4);
      return text.length > length ? text.slice(0, length) + imageFormat : text;
    },
    price: function(value = null) {
      if (value != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        var sNumber = Number(value.toString().match(re)[0]);
        let price = new Decimal(sNumber);
        return Number(price).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    }
  },
  mounted() {
    $("body").css({ backgroundColor: "#f4f5f8" });
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 845;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "./../../assets/styles/views/orders/_order_details.scss";
</style>

<style lang="scss">
#reason-for-cancellation {
  .col-form-label.cancellation-label {
    color: #49545c;
    font-size: 14px;
  }
  p {
    font-size: 16px;
    color: #2f3941;
  }
}
.w-15 {
  width: 15%;
}
.w-90 {
  width: 90%;
}
.word-break-all {
  word-break: break-word;
}
</style>
